import { render } from "./SessionReport.vue?vue&type=template&id=a228e782&scoped=true"
import script from "./SessionReport.vue?vue&type=script&lang=js"
export * from "./SessionReport.vue?vue&type=script&lang=js"

import "./SessionReport.vue?vue&type=style&index=0&id=a228e782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a228e782"]])

export default __exports__